import { render, staticRenderFns } from "./SearchNotFound.vue?vue&type=template&id=299fbdd9&scoped=true"
import script from "./SearchNotFound.vue?vue&type=script&lang=js"
export * from "./SearchNotFound.vue?vue&type=script&lang=js"
import style0 from "./SearchNotFound.vue?vue&type=style&index=0&id=299fbdd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299fbdd9",
  null
  
)

export default component.exports